module.exports = __webpack_public_path__ + "img/11P.261451b2.jpg";